import React from 'react';
import { useNavigate } from "react-router-dom";

const InstagramShareButton = ({ imageUrl, campaignId, reward, chances, congratsImage, tnxId }) => {

    const navigate = useNavigate();

    return (
        <button style={{ border: 'none', marginRight: '10px', backgroundColor: 'white' }} onClick={()=> {
            navigate(`/visa-japan/gamification/sharing`, {
                state: {
                    reward: reward,
                    chances: chances,
                    campaignId: campaignId,
                    congratsImage: congratsImage,
                    type: 'instagram',
                    imageUrl: imageUrl,
                    tnxId: tnxId
                }
            });
        }}>
            <img src={require('../../../images/instagram-icon.png')} alt="Instagram" />
        </button>
    );
};

export default InstagramShareButton;